import { useTranslation } from "react-i18next";
import Arman from "../../assets/team/Arman.jpeg";
import Diana from "../../assets/team/Diana.JPG";
import Alexander from "../../assets/team/Alexander.JPG";
import { Link } from "react-router-dom";

const AboutUs = () => {
  const { t } = useTranslation();
  
  // 🔹 Безопасное получение массивов с проверкой
  const getArray = (key) => {
    const value = t(key, { returnObjects: true });
    // Если вернулась строка (ключ), значит массив не найден
    if (typeof value === 'string' && value === key) {
      console.warn(`⚠️ Translation array "${key}" not found, using empty array`);
      return [];
    }
    // Если это уже массив - возвращаем его
    if (Array.isArray(value)) return value;
    // Если это объект - преобразуем в массив значений
    if (typeof value === 'object' && value !== null) return Object.values(value);
    // В остальных случаях - пустой массив
    return [];
  };

  const abouttexts = getArray("abouttext");
  const aboutlist = getArray("aboutlist");
  const whyustextlist = getArray("whyustextlist");
  const teaminfo = getArray("teaminfo");

  console.log("abouttexts:", abouttexts);
  console.log("aboutlist:", aboutlist);
  console.log("whyustextlist:", whyustextlist);
  console.log("teaminfo:", teaminfo);

  return (
    <section className="p-6 opacity-0 backdrop-blur-2xl animate-[showtitle_1s_forwards]">
     
      <section className="mt-12 text-white">
        <h1 className="text-4xl max-md:text-2xl font-semibold uppercase text-white mb-6">
          {t("aboutus")}
        </h1>
        <div className="flex w-[80%] max-md:w-full justify-start items-start flex-col gap-1">
          {abouttexts.map((item, index) => {
            return index === 1 ? (
              <h2
                key={index}
                className="text-white text-2xl font-semibold mt-6 mb-4"
              >
                {item}
              </h2>
            ) : (
              <p
                key={index}
                className="text-white max-sm:text-sm text-lg leading-relaxed mb-3"
              >
                {item}
              </p>
            );
          })}
        </div>
        <div className="w-[80%] max-md:w-full">
          <ul className="list-disc max-sm:text-sm ml-5 mt-6">
            {aboutlist.map((item, index) => {
              return <li key={index}>{item}</li>;
            })}
          </ul>

          <h1 className="text-3xl font-semibold mt-6">{t("foremployers")}</h1>
          <p className="mt-6 max-sm:text-sm">{t("foremployaertext")}</p>

          <Link className="flex w-max mt-6 underline" to="/EmployerChoose">
            {t("registerwithemployer")}
          </Link>

          <h1 className="text-3xl font-semibold mt-6">{t("forcandidates")}</h1>
          <p className="mt-6 max-sm:text-sm">{t("forcandidatestext")}</p>
          <Link className="flex w-max mt-6 underline" to="/WorkerChoose">
            {t("registerwithcandidate")}
          </Link>
          <h1 className="text-2xl font-semibold mt-6">{t("wepilicophy")}</h1>
          <p className="mt-6 max-sm:text-sm">{t("pilosophytext1")}</p>
          <h1 className="text-2xl uppercase font-semibold mt-6">{t("whyus")}</h1>
          <ul className="list-disc max-sm:text-sm ml-5 mt-6 flex flex-col gap-1">
            {whyustextlist.map((item, index) => {
              return <li key={index}>{item}</li>;
            })}
          </ul>
          <h1 className="text-2xl uppercase font-semibold mt-6">
            {t("PRICING POLICY")}
          </h1>
          <p className="mt-6">{t("policytext")}</p>

          <h1 className="text-2xl uppercase font-semibold mt-6">{t("news")}</h1>
          <p className="mt-6">{t("newstext1")}</p>
          <p className="mt-6">{t("newstext2")}</p>

          <h1 className="text-2xl uppercase font-semibold mt-6">{t("banner")}</h1>
          <p className="mt-6">{t("bannertext")}</p>
          <h1 className="text-2xl uppercase font-semibold mt-6">{t("addbanner")}</h1>
          <p className="mt-6">{t("finaltext1")}</p>
          <p className="mt-6">{t("finaltext2")}</p>
          <p className="mt-6">{t("finaltext3")}</p>
          <Link className="underline mt-6 flex w-max" to='/RegisterChoose'>{t("registernow")}</Link>
        </div>
      </section>
      <h1 className="text-4xl mt-12 max-md:text-2xl max-sm:text-xl opacity-0 animate-[showtitle_1s_forwards] font-bold uppercase text-white mb-6">
        {t("ourteam")}
      </h1>
      <section className="flex justify-center max-lg:flex-wrap items-start gap-6">
        <article
          className="w-full opacity-0 shadow-2xl rounded-2xl p-3 bg-black/30 gap-6 animate-[showtitle_1s_forwards] overflow-hidden flex justify-start items-start"
          style={{ animationDelay: "150ms" }}
        >
          <img
            className="w-[100px] h-[120px] rounded-2xl object-cover"
            src={Diana}
            alt=""
          />
          <ul className="translate-y-3">
            <li className="text-2xl max-sm:text-xl font-semibold text-white">{t("Diana")}</li>
            <li className="text-xl max-sm:text-[17px] text-white">{t("Dianainfo")}</li>
          </ul>
        </article>
        <article
          className="w-full opacity-0 shadow-2xl rounded-2xl p-3 bg-black/30 gap-6 animate-[showtitle_1s_forwards] overflow-hidden flex justify-start items-start"
          style={{ animationDelay: "350ms" }}
        >
          <img
            className="size-[100px] h-[120px] rounded-2xl object-cover"
            src={Alexander}
            alt=""
          />
          <ul className="translate-y-3">
            <li className="text-2xl max-sm:text-xl font-semibold text-white">
              {t("Alexander")}
            </li>
            <li className="text-xl max-sm:text-[17px] text-white">{t("Alexanderinfo")}</li>
          </ul>
        </article>
        <article
          className="w-full opacity-0 shadow-2xl rounded-2xl p-3 bg-black/30 gap-6 animate-[showtitle_1s_forwards] overflow-hidden flex justify-start items-start"
          style={{ animationDelay: "550ms" }}
        >
          <img
            className="size-[100px] h-[120px] rounded-2xl object-cover"
            src={Arman}
            alt=""
          />
          <ul className="translate-y-3">
            <li className="text-2xl max-sm:text-xl font-semibold text-white">{t("Arman")}</li>
            <li className="text-xl max-sm:text-[17px] text-white">{t("Armaninfo")}</li>
          </ul>
        </article>
      </section>
      <ul className="list-disc max-sm:text-sm ml-5 text-white mt-6 flex flex-col gap-3">
        {teaminfo.map((item, index) => {
          return <li key={index}>{item}</li>;
        })}
      </ul>
    </section>
  );
};

export default AboutUs;